import imageProject from './img/project.png'
import imageContext from './img/womany-project-banner.png'
import imagePlan from './img/plan.png'
import imageFocusGroup from './img/M123-Womany_M1.png'
import imageMiro from './img/M123-Womany_M2.png'
import imageFieldStudy from './img/M123-Womany_M3.png'

import imageDesign1 from './img/M123-Womany_P1.png'
import imageDesign2 from './img/M123-Womany_P2.png'
import imageDesign3 from './img/M123-Womany_P3.png'
import imageDesign4 from './img/M123-Womany_P4.png'

import media1 from './img/media/media1.png'
import media2 from './img/media/media2.png'
import media3 from './img/media/media3.png'
import media4 from './img/media/media4.png'

import imageMore1 from './img/more/0_main.png'
import imageMore2 from './img/more/0_x.PNG'
import imageMore3 from './img/more/0_y.PNG'
import imageMore4 from './img/more/1.PNG'
import imageMore5 from './img/more/2.PNG'
import imageMore6 from './img/more/3.PNG'
import imageMore7 from './img/more/4.PNG'
import imageMore8 from './img/more/5.PNG'
import imageMore9 from './img/more/6.jpg'
import imageMore10 from './img/more/7.PNG'
import imageMore11 from './img/more/8.PNG'
import imageMore12 from './img/more/9.jpg'

const images = {

  singles: {
    imageProject:    { src: imageProject, alt: 'Womany Design' },
    imageContext:    { src: imageContext, alt: 'Womany Design' },
    imagePlan:       { src: imagePlan, alt: 'Womany Design' },
    imageFocusGroup: { src: imageFocusGroup, alt: 'Womany Use Scenario' },
    imageMiro:       { src: imageMiro, alt: 'Womany Use Scenario' },
    imageFieldStudy: { src: imageFieldStudy, alt: 'Womany Use Scenario' },
  },

  design: [
    { src: imageDesign1, alt: 'Womany Design' },
    { src: imageDesign2, alt: 'Womany Design' },
    { src: imageDesign3, alt: 'Womany Design' },
    { src: imageDesign4, alt: 'Womany Use Scenario' },
  ],

  media: [
    { src: media1, alt: 'Womany Design' },
    { src: media2, alt: 'Womany Design' },
    { src: media3, alt: 'Womany Design' },
    { src: media4, alt: 'Womany Use Scenario' },
  ],

  more: [
    { src: imageMore1, alt: 'Womany Design' },
    { src: imageMore2, alt: 'Womany Design' },
    { src: imageMore3, alt: 'Womany Design' },
    { src: imageMore4, alt: 'Womany Use Scenario' },
    { src: imageMore5, alt: 'Womany Design' },
    { src: imageMore6, alt: 'Womany Design' },
    { src: imageMore7, alt: 'Womany Design' },
    { src: imageMore8, alt: 'Womany Use Scenario' },
    { src: imageMore9, alt: 'Womany Design' },
    { src: imageMore10, alt: 'Womany Use Scenario' },
    { src: imageMore11, alt: 'Womany Use Scenario' },
    { src: imageMore12, alt: 'Womany Use Scenario' },
  ],
};

export default images;